import {
  API_GET_DICTIONARY_RAYON_FOR_OBL,
  API_SETTLEMENT,
  API_SETTLEMENT_CREATE,
  API_SETTLEMENT_UPDATE,
  API_SETTLEMENTS,
  MAIN_URL,
  PORT,
  PORT_FOR_AUTH,
} from "../../../constants/constants";
import {
  GET_RAYON_BY_OBLAST_SETTLEMENTS,
  GET_RAYON_FOR_MODAL,
  GET_SETTLEMENT,
  GET_SETTLEMENTS,
  GET_SETTLEMENTS_ERROR,
  GET_SETTLEMENTS_NO_ERROR,
} from "../../types";
import { fetchWithToken } from "../../../interceptors/fetchInterceptor";
import { setRayon } from "../../../components/GeneralComponents/SearchBlock/inputsHeaders";

export const getSettlementsBySearchParams = (params) => {
  return async (dispatch) => {
    const request = await fetchWithToken(
      MAIN_URL + PORT_FOR_AUTH + API_SETTLEMENTS,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      },
    );

    const response = await request.json();

    dispatch({
      type: GET_SETTLEMENTS,
      data: response,
    });
  };
};

export const getRayonByOblastForSearch = (id) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT + API_GET_DICTIONARY_RAYON_FOR_OBL + id,
    );

    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        value: item.id,
        label: item.name,
        key: "rayon",
      };
    });

    setRayon(dataValid);

    dispatch({
      type: GET_RAYON_BY_OBLAST_SETTLEMENTS,
      data: dataValid,
    });
  };
};

export const getSettlements = (id) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT_FOR_AUTH + API_SETTLEMENT + id,
    );
    const data = await response.json();

    dispatch({
      type: GET_SETTLEMENT,
      data: data,
    });
  };
};

export const getRayonForModal = (id) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT + API_GET_DICTIONARY_RAYON_FOR_OBL + id,
    );

    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        value: item.id,
        label: item.name,
        key: "rayonId",
      };
    });

    dispatch({
      type: GET_RAYON_FOR_MODAL,
      data: dataValid,
    });
  };
};

export const createSettlement = (data, searchParams) => {
  return async (dispatch) => {
    const res = await fetchWithToken(
      MAIN_URL + PORT_FOR_AUTH + API_SETTLEMENT_CREATE,
      {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    if (res.status === 200) {
      dispatch(getSettlementsBySearchParams(searchParams));
      dispatch({
        type: GET_SETTLEMENTS_NO_ERROR,
        data: "",
      });
    } else {
      const dataErr = await res.text();
      dispatch({
        type: GET_SETTLEMENTS_ERROR,
        data: dataErr,
      });
    }
  };
};

export const updateSettlement = (id, data, searchParams) => {
  return async (dispatch) => {
    const res = await fetchWithToken(
      MAIN_URL + PORT_FOR_AUTH + API_SETTLEMENT_UPDATE + id,
      {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    if (res.status === 200) {
      dispatch(getSettlementsBySearchParams(searchParams));
      dispatch({
        type: GET_SETTLEMENTS_NO_ERROR,
        data: "",
      });
    } else {
      const dataErr = await res.text();
      dispatch({
        type: GET_SETTLEMENTS_ERROR,
        data: dataErr,
      });
    }
  };
};
